'use client'

import { ComponentProps, ReactNode } from 'react'

import { useRouter } from '@/shared/i18n'
import { cn } from '@/shared/lib'
import { Icon } from '@/shared/ui'

type Props = {
  onBackButtonClick?: () => void
  children: ReactNode
  iconName?: ComponentProps<typeof Icon>['name']
  className?: string
  buttonClassName?: string
  titleClassName?: string
}

export const CardHeader = ({
  children,
  onBackButtonClick,
  iconName = 'arrowbar-left',
  className,
  buttonClassName,
  titleClassName,
}: Props) => {
  const router = useRouter()

  const handleBackButtonClick = () => {
    if (onBackButtonClick) {
      onBackButtonClick()

      return
    }

    router.back()
  }

  return (
    <div
      className={cn(
        'relative mx-auto flex h-14 w-[700px] shrink-0 items-center justify-center bg-white',
        className,
      )}
    >
      <button
        className={cn(
          'absolute top-1/2 left-6 -translate-y-1/2 cursor-pointer',
          buttonClassName,
        )}
        onClick={handleBackButtonClick}
      >
        <Icon
          name={iconName}
          size={24}
          strokeWidth={1.5}
          className="text-black"
        />
        <span className="sr-only">이전으로 돌아가기</span>
      </button>
      <h2 className={cn('typo-label1 font-normal text-black', titleClassName)}>
        {children}
      </h2>
    </div>
  )
}
